/* eslint-disable */
import React from "react";
import { Button, Tooltip } from "@mantine/core";
import type { ButtonProps } from "@mantine/core";
import { useHasPermission } from "./useHasPermission";

type PermissionButtonProps = ButtonProps & {
  permission: string;
  hideIfNo?: boolean;
  tooltipIfNo?: string;
  onClick?: (e?: React.MouseEvent) => void;
};

export const PermissionButton: React.FC<PermissionButtonProps> = ({
  permission,
  hideIfNo = false,
  tooltipIfNo = "You don't have permission",
  children,
  onClick,
  ...rest
}) => {
  const { has, isLoading } = useHasPermission(permission);

  console.log("PermissionButton:", { permission, has, isLoading });

  const handleClick = (e?: React.MouseEvent) => {
    try {
      if (e && typeof e.preventDefault === "function") e.preventDefault();
      if (onClick) onClick(e);
    } catch (err) {
      console.error("Error in PermissionButton onClick:", err);
    }
  };

  if (isLoading) {
    return (
      <Button type="button" disabled {...rest}>
        {children}
      </Button>
    );
  }

  if (!has) {
    if (hideIfNo) return null;
    return (
      <Tooltip label={tooltipIfNo} withArrow>
        <div style={{ display: "inline-block" }}>
          <Button type="button" disabled {...rest}>
            {children}
          </Button>
        </div>
      </Tooltip>
    );
  }

  return (
    <Button type="button" onClick={handleClick} {...rest}>
      {children}
    </Button>
  );
};
